import type { ProjectKeysStoreState } from './project-keys.type'

export const projectKeysInitialState: Pick<
  ProjectKeysStoreState,
  'groups' | 'loading' | 'error' | 'selectedGroupId' | 'pendingSecrets'
> = {
  groups: [],
  loading: false,
  error: null,
  selectedGroupId: null,
  pendingSecrets: null,
}
